export const RECOMMENDED = 'ranking';
export const ALPHABETICAL = 'name';
export const EARN_RATE = 'earn_rate';
export const RANDOM = 'random';
